import {useTranslation} from 'react-i18next';
import Search from '../../assets/icons/search';
import * as css from './SearchFilterBar.css';

type Props = {
    search: string;
    onSearch: (value: string) => void;
    dataCy?: string;
};

const SearchFilterBar = ({search, onSearch, dataCy = 'searchFilter'}: Props) => {
    const {t} = useTranslation('timetable');

    return (
        <css.bar>
            <css.searchPill data-cy={`${dataCy}-search`}>
                <css.searchInput
                    type="text"
                    value={search}
                    onChange={e => onSearch(e.target.value)}
                    placeholder={t('search')}
                    aria-label={t('search')}
                />
                <Search />
            </css.searchPill>
        </css.bar>
    );
};

export default SearchFilterBar;
